import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    dataGrid: {
      maxHeight: '100%',
      borderRadius: `0px 0px ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
      '& .MuiDataGrid-cell': {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        whiteSpace: 'pre-line',
      },
    },
  };
};
